import axios from "axios";

const HOST_ = window.location.hostname || "localhost";
const ENDPOINT = 'token'
const API_URL = `http://${HOST_}:${process.env.REACT_APP_KAH_PORT}` // Specify login endpoint server or leave blank to use localhost
const ENDPOINT_TOKEN = 'token'
const ENDPOINT_REGISTER = 'register'

const key_semidpairs = 'semidpairs';

export const reduceApiPayload = (payload: any) => {
    /**
     * Expected Reduced Payload
     *  - token
     *  - user 
     * - first: string,
     * - last: string,
     * - roles: string[], //pi
     * - userid: string,
     * - allsemids: string[],
     * - semidpairs: string[],
     * - instruments: string
    */
  
    try {
  
      const userinfo_obj = JSON.parse(payload.user_payload.userinfo);
  
      // payload semid pair format - "instrument:semid"
      const instr_ = payload.user_payload.semidpairs.map((x: string) => {
        return x.split(':')[0]
      });
      const semids_ = payload.user_payload.semidpairs.map((x: string) => {
        console.log(x.split(':')[0])
        return x.split(':')[1]
      });
      let reduced_payload = {
        token: payload.token,
        user: {
          userid: userinfo_obj.userid,
          first: userinfo_obj.first,
          last: userinfo_obj.last,
          email: userinfo_obj.email,
          roles: userinfo_obj.roles,
          allsemids: payload.user_payload.all_semids,
          semidpairs: payload.user_payload.semidpairs,
          semids: semids_,
          instruments: instr_,
        }
      };
  
      return reduced_payload
    } catch (err) {
      console.log(`err while reducing`)
      console.log(err)
    }
  
  }
  
export default axios.create({
    baseURL: API_URL
});
